import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.member;

export const memberSelectors = {
  members: createSelector(selector, (member) => member.members),
  selectedMember: createSelector(selector, (member) => member.selectedMember),
};
